var UTILS = require("../libs/utils.js");
var config = require("../config.js");
function Projectile() {
  this.init = function (p16954, p16955, p16956, p16957, p16958, p16959, p16960, p16961, p16962) {
    p16962 = p16962 || {};
    p16961 = p16961 || {};
    this.x = p16954;
    this.y = p16955;
    this.z = p16956;
    this.spd = p16959.spd * (p16962.v || 1) * (p16962.pjSp == null ? 1 : p16962.pjSp);
    this.grav = p16962.pjG == null ? p16959.grav : p16962.pjG;
    this.range = p16959.range;
    if (p16961.rangeMlt) {
      this.range *= p16961.rangeMlt;
    }
    this.hitBox = p16959.hitB * (p16962.pjSC || 1);
    p16957 -= Math.PI;
    this.xD = p16957;
    this.yD = p16958;
    this.xS = this.spd * Math.sin(this.xD) * Math.cos(this.yD);
    this.zS = this.spd * Math.cos(this.xD) * Math.cos(this.yD);
    this.yS = this.spd * Math.sin(this.yD);
    this.dmg = +Math.ceil(p16959.dmg * (p16962.d || 1));
    if (p16961.dmgMlt) {
      this.dmg *= p16961.dmgMlt;
    }
    this.linger = p16959.linger;
    this.owner = p16960;
    this.stateConst = p16960 && !p16959.dontPred ? p16960.ping * 2 * p16960.lagComp : 0;
    this.dontPred = !!p16959.dontPred;
    this.weaponId = parseInt(p16961.wId);
    if (!UTILS.isNumber(this.weaponId)) {
      this.weaponId = undefined;
    }
    this.weapon = p16961.w;
    this.streak = p16961.stk;
    this.skipMove = true;
    this.noObjColl = !!p16962.noObjC;
    this.eDmg = p16959.eDmg;
    this.expl = p16959.explode;
    this.explDat = p16959.explodeData;
    if (p16962.ex != null) {
      this.eDmg = p16962.ex;
      this.expl = p16962.expS || 35;
    }
    this.effectInd = p16962.effectInd == null ? p16959.effectInd : p16962.effectInd;
    this.effectC = 1;
    if (p16961.effectInd != null) {
      this.effectInd = parseInt(p16961.effectInd);
    }
    if (p16961.effectC != null) {
      this.effectC = parseInt(p16961.effectC);
    }
    this.spray = p16962.spr || null;
    this.nImp = p16959.nImp;
    this.life = p16959.life;
    this.stick = p16959.stick;
    this.travelTime = 0;
    this.active = true;
    this.src = p16962.src;
    this.s = p16962.s;
  };
  this.update = function (delta) {
    if (this.active) {
      this.travelTime += delta;
      if (this.skipMove) {
        this.skipMove = false;
      } else {
        if (this.grav) {
          this.yS -= this.grav * delta;
          this.spd = UTILS.getD3D(0, 0, 0, this.xS, this.yS, this.zS);
          this.yD = Math.asin(this.yS / this.spd);
        }
        this.x += this.xS * delta;
        this.z += this.zS * delta;
        this.y += this.yS * delta;
        if (this.life) {
          this.life -= delta;
          if (this.life <= 0) {
            this.life = 0;
            this.active = false;
          }
        }
        this.range -= this.spd * delta;
        if (this.range <= 0) {
          this.active = false;
        }
      }
    }
  };
}
module.exports = function (game, p16965) {
  var v13599;
  var v13600;
  var v13601;
  var v13602;
  var vA771 = [];
  this.projectiles = [];
  this.stored = [{
    spd: 0.38,
    grav: 0.0002,
    spn: 0.035,
    scale: 1,
    linger: 5000,
    length: 1,
    dmg: 180,
    range: 1500
  }, {
    spd: 0.1,
    grav: 0,
    spn: 0.04,
    hitB: 4,
    scale: 6.1,
    length: 6.1,
    dmg: 1,
    range: 500,
    life: 24000
  }, {
    s: "streak_3",
    spn: 0.008,
    spnD: "y",
    spd: 0.4,
    scale: 5,
    length: 5,
    scaleMlt: 2,
    explode: 150,
    dmg: 150,
    eDmg: 150,
    range: 1500,
    life: 24000,
    dontPred: true,
    info: {
      stk: 3
    },
    yD: -(Math.PI / 2),
    rot: Math.PI,
    blend: 1,
    noLookAt: true,
    depthW: true,
    explodeData: {
      smCnt: 5,
      lgCnt: 0
    }
  }];
  this.update = function (delta) {
    for (var vLN02501 = 0; vLN02501 < this.projectiles.length; ++vLN02501) {
      v13602 = this.projectiles[vLN02501];
      if (v13602.active) {
        v13602.update(delta);
        if (v13602.active) {
          var v13603 = false;
          var v13604 = false;
          var v13605 = v13602.spd * delta;
          vA771.length = 0;
          var v13606 = 1 / (v13605 * Math.sin(v13602.xD) * Math.cos(v13602.yD));
          var v13607 = 1 / (v13605 * Math.cos(v13602.xD) * Math.cos(v13602.yD));
          var v13608 = 1 / (v13605 * Math.sin(v13602.yD));
          if (!v13602.noObjColl) {
            for (var vLN02502 = 0; vLN02502 < game.map.manager.objects.length; ++vLN02502) {
              v13600 = game.map.manager.objects[vLN02502];
              if (!v13600.noShoot && v13600.active) {
                var v13609 = UTILS.lineInRect(v13602.x, v13602.z, v13602.y, v13606, v13607, v13608, v13600.x - v13600.width, v13600.z - v13600.length, v13600.y - v13600.height, v13600.x + v13600.width, v13600.z + v13600.length, v13600.y + v13600.height);
                if (v13609 && v13609 <= 1) {
                  vA771.push({
                    obj: v13600,
                    dst: v13609
                  });
                }
              }
            }
          }
          for (var vLN02505 = 0; vLN02505 < game.players.list.length; ++vLN02505) {
            v13601 = game.players.list[vLN02505];
            if (v13601.active && v13601 != v13602.owner && !v13601.noPVP && !v13602.owner.noPVP && (v13601.forcePVP && v13602.owner.forcePVP || !v13601.forcePVP && !v13602.owner.forcePVP)) {
              if (v13602.streak != null && v13602.owner == v13601) {
                continue;
              }
              v13600 = game.players.fetchState(v13601, v13602.owner, 0, v13602.travelTime);
              if (!v13600) {
                continue;
              }
              var v13610 = null;
              if (v13602.hitBox) {
                v13610 = UTILS.getD3D(v13602.x, v13602.y, v13602.z, v13600.x, v13600.y + v13600.ah / 2, v13600.z);
                if (v13610 <= v13602.hitBox) {
                  v13610 /= v13602.hitBox;
                } else {
                  v13610 = null;
                }
              } else {
                v13610 = UTILS.lineInRect(v13602.x, v13602.z, v13602.y, v13606, v13607, v13608, v13600.x - v13601.scale - v13601.hitboxPadW, v13600.z - v13601.scale - v13601.hitboxPadW, v13600.y, v13600.x + v13601.scale + v13601.hitboxPadW, v13600.z + v13601.scale + v13601.hitboxPadW, v13600.y + v13600.ah + v13601.hitboxPadH);
              }
              if (v13610 && v13610 <= 1) {
                vA771.push({
                  plr: true,
                  obj: game.players.list[vLN02505],
                  dst: v13610
                });
              }
            }
          }
          for (var vLN02504 = 0; vLN02504 < game.AI.ais.length; ++vLN02504) {
            v13600 = game.AI.ais[vLN02504];
            if (v13600.active && (!v13600.team || !v13602.owner || v13600.team != v13602.owner.team) && v13602.owner != v13600) {
              var v13611 = UTILS.lineInRect(v13602.x, v13602.z, v13602.y, v13606, v13607, v13608, v13600.x - v13600.scale, v13600.z - v13600.scale, v13600.y, v13600.x + v13600.scale, v13600.z + v13600.scale, v13600.y + v13600.height * 2);
              if (v13611 && v13611 <= 1) {
                vA771.push({
                  ai: true,
                  obj: game.AI.ais[vLN02504],
                  dst: v13611
                });
              }
            }
          }
          var v13612 = game.map.terrain;
          if (v13612) {
            var v13613 = v13612.raycast(v13602.x, -v13602.z, v13602.y, 1 / v13606, -1 / v13607, 1 / v13608);
            if (v13613) {
              let v13614 = UTILS.getD3D(v13602.x, v13602.y, v13602.z, v13613.x, v13613.z, -v13613.y);
              vA771.push({
                dst: v13614 / v13605
              });
            }
          }
          var vV13605 = v13605;
          if (vA771.length) {
            vA771.sort(UTILS.orderByDst);
            if (vA771[0]) {
              vV13605 = v13605 * vA771[0].dst;
              var v13615 = false;
              var v13616 = false;
              var v13617 = +v13602.dmg;
              if (v13602.owner && v13602.owner.smite) {
                v13617 = 10000;
              }
              if (v13602.owner && v13602.owner.attributes && v13602.owner.attributes.dmg) {
                v13617 *= v13602.owner.attributes.dmg;
              }
              if (v13602.owner && v13602.owner.dmgMlt) {
                v13617 *= v13602.owner.dmgMlt;
              }
              if (!UTILS.isNumber(v13617)) {
                continue;
              }
              if (!vA771[0].plr && !vA771[0].ai) {
                v13603 = true;
              }
              if (!vA771[0].ai) {
                if (v13602.owner && v13602.owner.isPlayer && v13617 && v13617 > 0 && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && vA771[0].obj && vA771[0].obj.health && !vA771[0].plr) {
                  vA771[0].obj.health -= v13617;
                  v13602.owner.send("4");
                  if (vA771[0].obj.health <= 0) {
                    vA771[0].obj.active = false;
                    vA771[0].obj.health = 0;
                    vA771[0].obj.destroyedBy = v13602.owner;
                    vA771[0].obj.destroyed = true;
                    game.map.manager.destObjs.push(vA771[0].obj.uid);
                    game.broadcast("do", vA771[0].obj.uid);
                    if (vA771[0].obj && vA771[0].obj.onDestroy) {
                      game.onTrigger(v13602.owner, vA771[0].obj);
                    }
                  }
                }
              } else if (!vA771[0].obj.invincible) {
                if (v13602.effectInd != null) {
                  var v13622 = !v13602.owner || !v13602.owner.team || v13602.owner.team != vA771[0].obj.team || game.mode.dmgTeam || game.config.frFire;
                  if (v13622) {
                    vA771[0].obj.giveEffect(v13602.effectInd, v13602.effectC);
                    if (v13602.effectInd == 8 && v13602.owner && v13602.owner.isPlayer) {
                      vA771[0].obj.zappedBy = v13602.owner.sid;
                    }
                  }
                }
                vA771[0].obj.changeHealth(-v13617, v13602.owner, v13602.weaponId == 12);
                if (v13602.owner && v13602.owner.isPlayer) {
                  if (vA771[0].obj.killScore && game.mode && game.mode.pointsPerHit) {
                    game.players.score(v13602.owner, Math.ceil(v13617 * game.mode.pointsPerHit), 1);
                  }
                  if (!vA771[0].obj.active && vA771[0].obj.killScore) {
                    game.players.score(v13602.owner, vA771[0].obj.killScore, 1);
                  }
                  game.showHit(v13602.owner, vA771[0].obj, Math.round(v13617), false, true);
                }
              }
              if (v13602.owner && v13602.owner.isPlayer && vA771[0].obj && (vA771[0].obj.onShoot || vA771[0].obj.onDamage || v13602.owner && v13602.weaponId == 12 && vA771[0].obj.onThrowingMelee || vA771[0].obj.onProjectile)) {
                game.onTrigger(v13602.owner, vA771[0].obj);
              }
              if (v13602.owner && v13602.owner.isPlayer && vA771[0].obj && v13617 && vA771[0].obj.isEvent) {
                game.foundEventItem(v13602.owner, vA771[0].obj);
              }
              if (vA771[0].obj && v13617 && vA771[0].plr) {
                v13604 = true;
                if (v13602.owner && v13602.owner.isPlayer && v13602.weaponId != null) {
                  var v13619 = v13602.y + vV13605 * Math.sin(v13602.yD);
                  var v13620 = vA771[0].obj.y + vA771[0].obj.adjustedHeight - v13619;
                  game.players.debugHitbox(v13602.owner, vA771[0].obj, v13619);
                  var v13621 = game.weaponConfig[v13602.weaponId];
                  v13615 = v13620 < config.headScale;
                  if (v13615) {
                    v13617 *= v13615 && !v13621.noHeadShot ? v13621.hsMlt || 1.5 : 1;
                  } else if (!!game.config && game.config.headshotOnly) {
                    v13617 = 0;
                  }
                  v13616 = vA771[0].obj.y + config.legHeight - config.crouchDst * vA771[0].obj.crouchVal > v13619;
                  if (v13616 && !v13615) {
                    v13617 *= v13621.lsMlt || 0.5;
                  }
                }
                if (v13602.effectInd != null) {
                  var v13622 = !v13602.owner || !v13602.owner.isPlayer || !v13602.owner.team || v13602.owner.team != vA771[0].obj.team || game.mode.dmgTeam || game.config.frFire;
                  if (v13622) {
                    game.players.giveEffect(vA771[0].obj, v13602.effectInd, v13602.effectC);
                    if (v13602.effectInd == 8 && v13602.owner && v13602.owner.isPlayer) {
                      vA771[0].obj.zappedBy = v13602.owner.sid;
                    }
                  }
                }
                if (game.players.changeHealth(vA771[0].obj, v13602.owner, v13617, undefined, v13615, {
                  wep: v13602.weaponId
                })) {
                  if (v13602.owner && v13602.weaponId == 12) {
                    v13602.owner.tKnifeKills++;
                    if (p16965) {
                      game.incStat("tmk", v13602.owner);
                      game.challenges.update(game, "tmk", 1, {
                        wep: 12
                      }, v13602.owner);
                    }
                  }
                  if (v13602.owner && v13602.owner.isPlayer && v13615) {
                    v13602.owner.headshots++;
                    if (p16965) {
                      game.incStat("hs", v13602.owner);
                      game.challenges.update(game, "hs", 1, {
                        wep: v13602.weaponId
                      }, v13602.owner);
                    }
                  }
                  if (v13602.owner && v13602.owner.isPlayer && v13616) {
                    v13602.owner.legshots++;
                    if (p16965) {
                      game.incStat("ls", v13602.owner);
                      game.challenges.update(game, "ls", 1, {
                        wep: v13602.weaponId
                      }, v13602.owner);
                    }
                  }
                  game.players.kill(vA771[0].obj, v13602.owner, {
                    wId: v13602.weaponId,
                    stk: v13602.streak,
                    hs: v13615,
                    pj: true
                  }, false, v13602.streak != null);
                  if (v13602.streak != null && game.streaks[v13602.streak] && game.streaks[v13602.streak].onKill) {
                    game.streaks[v13602.streak].onKill(game, v13602.owner, p16965);
                  }
                } else if (v13602.streak != null && game.streaks[v13602.streak] && game.streaks[v13602.streak].onCollision) {
                  game.streaks[v13602.streak].onCollision(game, vA771[0].obj, p16965);
                }
              }
              vA771[0].dst -= 0.02;
              v13602.x += vA771[0].dst * (v13602.xS * delta);
              v13602.y += vA771[0].dst * (v13602.yS * delta);
              v13602.z += vA771[0].dst * (v13602.zS * delta);
            }
            v13602.active = false;
          }
          if (v13604 && p16965 && v13602.owner && v13602.owner.isPlayer) {
            game.incStat("h", v13602.owner);
          }
        }
        if (!v13602.active) {
          if (v13602.expl) {
            game.explosion(v13602.x, v13602.y, v13602.z, v13602.expl, v13602.eDmg, v13602.owner, {
              wId: v13602.weaponId,
              stk: v13602.streak,
              smCnt: v13602.explDat == null ? undefined : v13602.explDat.smCnt,
              lgCnt: v13602.explDat == null ? undefined : v13602.explDat.lgCnt
            }, false, v13602.streak != null);
          }
          if (v13602.spray && vA771.length && !vA771[0].plr && !vA771[0].ai) {
            game.players.sprayPosition(v13602.owner, vA771[0].obj, v13602.spray, v13602.x, v13602.y, v13602.z, v13602.s);
          }
          var v13623;
          for (var vLN02505 = 0; vLN02505 < game.players.list.length; ++vLN02505) {
            v13623 = game.players.list[vLN02505];
            if (v13623 != v13602.owner || v13602.dontPred) {
              game.players.list[vLN02505].send("pre", v13602.sid, 0, v13602.x.round(1), v13602.y.round(1), v13602.z.round(1), v13603 && !v13602.nImp && v13602.owner ? 1 : 0);
            } else {
              game.players.list[vLN02505].send("pre", v13602.ownShotCnt, 1, v13602.x.round(1), v13602.y.round(1), v13602.z.round(1), !v13603 || v13602.nImp ? 0 : 1);
            }
          }
        }
      }
    }
  };
  this.init = function (p16967, p16968, p16969, p16970, p16971, p16972, p16973, p16974, p16975, p16976) {
    p16970 = p16970.round(3);
    p16971 = p16971.round(3);
    p16967 = p16967.round(1);
    p16968 = p16968.round(1);
    p16969 = p16969.round(1);
    v13599 = null;
    for (var vLN02507 = 0; vLN02507 < this.projectiles.length; ++vLN02507) {
      if (!this.projectiles[vLN02507].active) {
        v13599 = this.projectiles[vLN02507];
        break;
      }
    }
    if (!v13599) {
      v13599 = new Projectile();
      v13599.sid = this.projectiles.length;
      this.projectiles.push(v13599);
    }
    v13599.init(p16967, p16968, p16969, p16970, p16971, p16972, p16973, p16974, p16976);
    v13599.ownShotCnt = p16973 ? p16973.shotCntP : null;
    var v13624;
    if (p16965) {
      for (var vLN02507 = 0; vLN02507 < game.players.list.length; ++vLN02507) {
        v13624 = game.players.list[vLN02507];
        if ((v13624 != p16973 || p16972.dontPred) && (v13624.active || v13624.spectating)) {
          if (p16975) {
            v13624.send("pr", p16967, p16968, p16969, p16970, p16971, this.stored.indexOf(p16972), v13599.sid, 1, p16976, p16973 ? p16973.sid : undefined);
          } else if (p16973 && p16973.isPlayer) {
            v13624.send("pr", p16967, p16968, p16969, p16970, p16971, p16973.loadout[p16973.loadoutIndex], v13599.sid, undefined, undefined, p16973.sid);
          }
        }
      }
    }
  };
  this.initBombs = function (p16977, p16978) {
    var v13625 = this.stored[2];
    var vA772 = [];
    for (var vLN02508 = 0; vLN02508 < p16977.length; vLN02508 += 3) {
      var v13626 = p16977[vLN02508].round(1);
      var v13627 = p16977[vLN02508 + 1].round(1);
      var v13628 = p16977[vLN02508 + 2].round(1);
      var v13629 = UTILS.randFloat(0.3, 0.7);
      var vO434 = {
        pjSp: v13629.round(3)
      };
      v13599 = null;
      for (var vLN02509 = 0; vLN02509 < this.projectiles.length; ++vLN02509) {
        if (!this.projectiles[vLN02509].active) {
          v13599 = this.projectiles[vLN02509];
          break;
        }
      }
      if (!v13599) {
        v13599 = new Projectile();
        v13599.sid = this.projectiles.length;
        this.projectiles.push(v13599);
      }
      v13599.init(v13626, v13627, v13628, 0, v13625.yD, v13625, p16978, v13625.info, vO434);
      v13599.ownShotCnt = p16978 ? p16978.shotCntP : null;
      vA772.push(v13626, v13627, v13628, v13599.sid, vO434);
    }
    if (p16965) {
      game.broadcast("bmb", vA772);
    }
  };
};